var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "signature-align-" + _vm.localAlign + " signature" },
    [
      !_vm.editingFieldLabel
        ? _c(
            "label",
            {
              staticClass: "field-label",
              attrs: { for: "signature" },
              on: { click: _vm.focusFieldLabel },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.displayFieldLabel) + "\n        "
              ),
              _vm.isRequired
                ? _c("span", { staticClass: "required-indicator" }, [
                    _vm._v("*"),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editingFieldLabel
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localFieldLabel,
                expression: "localFieldLabel",
              },
            ],
            ref: "fieldLabelInput",
            staticClass: "field-label-input",
            attrs: { type: "text", placeholder: "İmza" },
            domProps: { value: _vm.localFieldLabel },
            on: {
              blur: _vm.stopEditingFieldLabel,
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.stopEditingFieldLabel.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localFieldLabel = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "signature-container" }, [
        _c(
          "div",
          {
            staticClass: "signature-canvas-wrapper",
            style: _vm.canvasWrapperStyle,
          },
          [
            _c("canvas", {
              ref: "signatureCanvas",
              style: _vm.canvasStyle,
              attrs: { width: _vm.canvasWidth, height: _vm.canvasHeight },
              on: {
                mousedown: _vm.startDrawing,
                mousemove: _vm.draw,
                mouseup: _vm.stopDrawing,
                mouseleave: _vm.stopDrawing,
                touchstart: _vm.startDrawing,
                touchmove: _vm.draw,
                touchend: _vm.stopDrawing,
              },
            }),
            _vm._v(" "),
            _vm.isEmpty && !_vm.isDrawing
              ? _c("div", { staticClass: "signature-placeholder" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.placeholder || "Burada imza çizin") +
                      "\n            "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showClearButton && !_vm.isEmpty
              ? _c(
                  "button",
                  {
                    staticClass: "clear-button",
                    attrs: { type: "button" },
                    on: { click: _vm.clearSignature },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.clearButtonText || "Temizle") +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.altLabel
          ? _c("div", { staticClass: "alt-label" }, [
              _vm._v(_vm._s(_vm.altLabel)),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }